import {useCallback} from 'react'
import queryString from 'query-string'

function usePushUrlParams() {
  return useCallback((data: any) => {
    const stringifiedData = queryString.stringify(data)
    window.history.replaceState('', '', `?${stringifiedData}`)
  }, [])
}

export default usePushUrlParams
